import { render, staticRenderFns } from "./EmailMarketingPage.vue?vue&type=template&id=706a90a7&"
import script from "./EmailMarketingPage.vue?vue&type=script&lang=js&"
export * from "./EmailMarketingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports